document.addEventListener("DOMContentLoaded", function () {
    console.log("🔍 Winkelmand-check gestart...");

    // Collecties die niet gecombineerd mogen worden
    const restrictedCollections = [
        "signature by two rooms", 
        "project by two rooms", 
        "essentials by two rooms", 
        "projects by two rooms",
        "select by two rooms",
        "brauer gmbh"
    ];

    fetch("/cart.js")
        .then(response => {
            if (!response.ok) {
                throw new Error("Fout bij laden van winkelmandgegevens.");
            }
            return response.json();
        })
        .then(data => {
            console.log("✅ Winkelmandgegevens ontvangen:", data);
            if (!data.items) {
                console.warn("⚠️ Geen producten in winkelmand of fout bij ophalen.");
                return;
            }

            let cartItems = data.items;
            let collectionTracker = new Set();

            cartItems.forEach(item => {
                let detectedCollection = null;

                let vendorLower = item.vendor ? item.vendor.toLowerCase().trim() : "";
                let productTypeLower = item.product_type ? item.product_type.toLowerCase().trim() : "";
                let handleLower = item.handle ? item.handle.toLowerCase().trim() : "";

                console.log(`🛒 Product: ${item.product_title}`);
                console.log(`   📌 Handle: ${handleLower}`);
                console.log(`   🏷️ Vendor: ${vendorLower}`);
                console.log(`   🔹 Product Type: ${productTypeLower}`);

                // ✅ Controleer vendor (merken zoals Signature, Projects, etc.)
                if (restrictedCollections.includes(vendorLower)) {
                    detectedCollection = vendorLower;
                }

                // ✅ Controleer product type (mocht Shopify hier extra info zetten)
                if (restrictedCollections.includes(productTypeLower)) {
                    detectedCollection = productTypeLower;
                }

                // ✅ Controleer handle (voor extra veiligheid)
                restrictedCollections.forEach(restricted => {
                    if (handleLower.includes(restricted)) {
                        detectedCollection = restricted;
                    }
                });

                if (detectedCollection) {
                    collectionTracker.add(detectedCollection);
                    console.log(`✅ Collectie toegevoegd: ${detectedCollection}`);
                }
            });

            console.log("🎯 Unieke collecties in winkelmand:", collectionTracker);

            // ✅ FIX: De melding verschijnt ALTIJD als er minimaal 2 verschillende collecties zijn
            if (collectionTracker.size >= 2) {
                let warningMessage = "<strong>Let op:</strong> Je hebt producten uit verschillende collecties toegevoegd. Zorg ervoor dat de afwerkingen en stijlen goed bij elkaar passen.";

                let warningDiv = document.createElement("div");
                warningDiv.classList.add("custom-cart-warning");
                warningDiv.innerHTML = warningMessage; // innerHTML zodat <strong> werkt

                // ✅ Correct plaatsen onder het lichtblauwe vak
                let cartContainer = document.querySelector(".cart__container.page__inner");

                if (cartContainer) {
                    cartContainer.prepend(warningDiv);
                    console.log("🚨 Waarschuwing correct onder het lichtblauwe vak geplaatst.");
                } else {
                    console.log("⚠️ Geen correcte container gevonden. Plaatsen boven winkelmandinhoud.");
                    let cartContents = document.querySelector(".cart__contents") || document.body;
                    cartContents.prepend(warningDiv);
                }
            } else {
                console.log("✅ Geen conflicterende collecties gevonden. Geen waarschuwing nodig.");
            }
        })
        .catch(error => console.error("❌ Fout bij ophalen winkelmand:", error));
});
